import WellServices from './WellServices'

export default WellServices
